// Protože v některých státech je možné si vybrat z více možností.
export enum PayPeriod {
  /** Kalendářní měsíc. */
  Monthly = 'Monthly',
}
